export class Dashboard {
    
}